import React, { useEffect, useState } from "react";
import { Wrapper, Content } from "./sidenav.style";

import { Link } from "react-router-dom";
import { AxiosConnect } from "../../AxiosConnect";
import { AltRoute } from "@mui/icons-material";
import MENU_BAR from "../../utils/menu";

function SideNav({ show }) {
  const [open, setOpen] = useState(false);
  
  return (
    <Wrapper show={show}>
      <Content>
        {MENU_BAR &&
          MENU_BAR.map((x) => (
            <div>
              <a href={x.link}>
                <li className="half">{x.company}</li>
              </a>
            </div>
          ))}
      </Content>
    </Wrapper>
  );
}

export default SideNav;
